import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "cw_admin_token";

export const authToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const auth = () => ({ Authorization: `Bearer ${authToken.get()}` });

// Public
export const apiListProducts = async (params = {}) => {
  const { data } = await axios.get(`${BASE}/products`, { params });
  return data;
};
export const apiGetProduct = async (id) => {
  const { data } = await axios.get(`${BASE}/products/${id}`);
  return data;
};
export const apiValidateCoupon = async (code, subtotal) => {
  const { data } = await axios.post(`${BASE}/coupons/validate`, { code, subtotal });
  return data;
};
export const apiCreateOrder = async (payload) => {
  const { data } = await axios.post(`${BASE}/orders`, payload);
  return data;
};
export const apiSubscribe = async (email, source = "popup") => {
  const { data } = await axios.post(`${BASE}/subscribers`, { email, source });
  return data;
};
export const apiGetOrder = async (orderNumber) => {
  const { data } = await axios.get(`${BASE}/orders/${orderNumber}`);
  return data;
};
export const apiSubmitContact = async (payload) => {
  const { data } = await axios.post(`${BASE}/contact`, payload);
  return data;
};

// Admin auth
export const apiLogin = async (email, password) => {
  const { data } = await axios.post(`${BASE}/auth/login`, { email, password });
  authToken.set(data.token);
  return data;
};
export const apiMe = async () => {
  const { data } = await axios.get(`${BASE}/auth/me`, { headers: auth() });
  return data;
};

// Admin
export const apiAdminProducts = async () => (await axios.get(`${BASE}/admin/products`, { headers: auth() })).data;
export const apiAdminCreateProduct = async (p) => (await axios.post(`${BASE}/admin/products`, p, { headers: auth() })).data;
export const apiAdminUpdateProduct = async (id, p) => (await axios.put(`${BASE}/admin/products/${id}`, p, { headers: auth() })).data;
export const apiAdminDeleteProduct = async (id) => (await axios.delete(`${BASE}/admin/products/${id}`, { headers: auth() })).data;

export const apiAdminOrders = async () => (await axios.get(`${BASE}/admin/orders`, { headers: auth() })).data;
export const apiAdminUpdateOrderStatus = async (id, status) =>
  (await axios.put(`${BASE}/admin/orders/${id}/status`, { status }, { headers: auth() })).data;

export const apiAdminCoupons = async () => (await axios.get(`${BASE}/admin/coupons`, { headers: auth() })).data;
export const apiAdminCreateCoupon = async (c) => (await axios.post(`${BASE}/admin/coupons`, c, { headers: auth() })).data;
export const apiAdminUpdateCoupon = async (id, c) => (await axios.put(`${BASE}/admin/coupons/${id}`, c, { headers: auth() })).data;
export const apiAdminDeleteCoupon = async (id) => (await axios.delete(`${BASE}/admin/coupons/${id}`, { headers: auth() })).data;

export const apiAdminSubscribers = async () => (await axios.get(`${BASE}/admin/subscribers`, { headers: auth() })).data;
export const apiAdminStats = async () => (await axios.get(`${BASE}/admin/stats`, { headers: auth() })).data;
export const apiAdminRevenueTrend = async (days = 30) =>
  (await axios.get(`${BASE}/admin/stats/revenue?days=${days}`, { headers: auth() })).data;
export const apiAdminContacts = async () => (await axios.get(`${BASE}/admin/contacts`, { headers: auth() })).data;
export const apiAdminMarkContactHandled = async (id, handled = true) =>
  (await axios.put(`${BASE}/admin/contacts/${id}/handled`, { handled }, { headers: auth() })).data;
export const apiAdminUpdateSettings = async (s) =>
  (await axios.put(`${BASE}/admin/settings`, s, { headers: auth() })).data;

// Blog posts — public
export const apiListPosts = async () => (await axios.get(`${BASE}/posts`)).data;
export const apiGetPost = async (slug) => (await axios.get(`${BASE}/posts/${slug}`)).data;

// Blog posts — admin
export const apiAdminPosts = async () => (await axios.get(`${BASE}/admin/posts`, { headers: auth() })).data;
export const apiAdminCreatePost = async (p) =>
  (await axios.post(`${BASE}/admin/posts`, p, { headers: auth() })).data;
export const apiAdminUpdatePost = async (id, p) =>
  (await axios.put(`${BASE}/admin/posts/${id}`, p, { headers: auth() })).data;
export const apiAdminDeletePost = async (id) =>
  (await axios.delete(`${BASE}/admin/posts/${id}`, { headers: auth() })).data;
export const downloadAdminCsv = async (kind) => {
  const res = await fetch(`${BASE}/admin/exports/${kind}.csv`, { headers: auth() });
  if (!res.ok) throw new Error(`Failed to export ${kind}`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${kind}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
